__turbopack_context__.v({
  "discordIcon": "userDropdown-module-scss-module__TpIA3W__discordIcon",
  "dropdown": "userDropdown-module-scss-module__TpIA3W__dropdown",
  "dropdownContent": "userDropdown-module-scss-module__TpIA3W__dropdownContent",
  "dropdownItem": "userDropdown-module-scss-module__TpIA3W__dropdownItem",
  "userDropdownButton": "userDropdown-module-scss-module__TpIA3W__userDropdownButton",
});
